import React from 'react'
import './index.scss'

interface TagButtonProps {
    mainColor: boolean
    className?: string
    onClick?: () => void
    children?: React.ReactNode
}

const TagButton = (props: TagButtonProps) => {
    const { mainColor = true, className, onClick, children } = props

    const classNames = [mainColor ? 'main-color-set' : 'second-color-set', className].join(' ')

    return (
        <div className="tag-button-component" data-testid="tag-button-component">
            <button className={classNames} onClick={onClick}>
                {children}
            </button>
        </div>
    )
}

export default TagButton
